import React from 'react';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./Provider.css";
import provider1 from "../../Includes/Images/Group-1171275352-1-2.png";
import provider2 from "../../Includes/Images/Group-1171275359-1-1.png";
import provider3 from "../../Includes/Images/human-1.jpg";
import { Link } from 'react-router-dom';
import WideCoverage from './WideCoverage';

const XfinityTv = () => {
    // Consistent phone number across the page
    const phoneNumber = "+1-888-348-6689";

    return (
        <>
            <Header />
            <div className="xfnn-container">
                <header className="xfnn-header1">
                    <div className="xfnn-logo">xfinity</div>
                    <div className="xfnn-menu-toggle" id="menuToggle">☰</div>
                    <nav className="xfnn-nav" id="mobileNav">
                        <Link to="/xfinity" className="xfnn-nav-item">XFINITY</Link>
                        <Link to="/xfinity-internet" className="xfnn-nav-item">XFINITY INTERNET</Link>
                        <Link to="/xfinity-tv" className="xfnn-nav-item">XFINITY TV</Link>
                    </nav>
                </header>

                <section className="xfnn-hero3">
                    <div className="xfnn-hero-content">
                        <div className="xfnn-ghost-text">XFINITY</div>
                        <h1 className="xfnn-hero-title">TV Plans<br />Prices, &<br />Deals</h1>
                        <ul className="xfnn-features">
                            <li>Enjoy uninterrupted entertainment with over 185 channels, including premium networks, offered by Xfinity cable TV, trusted by millions of customers nationwide.</li>
                        </ul>
                        <div className="xfnn-price">
                            <span className="xfnn-dollar-sign">$</span>19.99<span className="xfnn-price-month">/MO</span>
                        </div>
                        <br />
                        <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="xfnn-phone">
                            <i className="fas fa-phone-alt"></i> {phoneNumber}
                        </a>
                    </div>
                    <div className="xfnn-hero-image">
                        {/* Background image is set in CSS using provider2 */}
                    </div>
                </section>

                <section className="xfnn-services">
                    <h2 className="xfnn-heading-title">XFINITY<br />INTERNET</h2>
                    <h2 className="xfnn-services-title">Evaluating, Xfinity<br />Internet</h2>

                    <div className="xfnn-services-grid">
                        <div className="xfnn-services-images">
                            <div className="xfnn-image-container main-image">
                                <img src={provider1} alt="Woman with colorful lighting" className="xfnn-full-image" />
                            </div>
                        </div>
                        <div className="xfnn-services-content">
                            <p className="xfnn-services-text">
                                According to the J.D. Power US Residential Internet Service Provider Satisfaction Study, Xfinity is among the top 3 providers in the West, South, North Central, and East US divisions. The brand’s social media reviews are also largely satisfactory.</p>

                            <p className="xfnn-services-text">Xfinity internet plans offer download speeds of up to 1,200 Mbps (subject to availability) and come with a 1.2 Terabyte data limit.</p>

                            <p className="xfnn-services-text">While this is sufficient monthly data for most users, you can add unlimited data to any Xfinity internet plan for an additional $25 per month with xFi Complete and also enjoy wall-to-wall coverage and Advanced Security.</p>

                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="xfnn-cta-button">
                                <i className="fas fa-phone-alt"></i> {phoneNumber}
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            <div className="offers-container">
                <div className="offers-header">
                    <h2 className="xfnn-services-title">Best Xfinity Offers</h2>
                </div>

                <div className="offers-cards">
                    {/* Basic Plan */}
                    <div className="offer-card offer-card-basic">
                        <div className="offer-header">
                            <h3 className="offer-name">Ultimate TV
</h3>
                            <p className="offer-price">$68.50<span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Access to 185+ channels</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Popular channels including NFL Network, NBA TV, MLB Network</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">20 Hour DVR service + HD (X1 TV box separate)</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Xfinity Stream TV App</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">X1 Voice Remote</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Thousands of On Demand movies and TV shows</span>
    </div>
</div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Standard Plan */}
                    <div className="offer-card offer-card-standard">
                        <div className="standard-offer-header">
                            <h3 className="offer-name">Fast Internet + Popular TV + Voice

</h3>
                            <p className="standard-offer-price">$95<span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Access to 125+ channels</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Download speeds up to 500 Mbps</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">20 Hour DVR service + HD (X1 TV box separate)</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">HD streaming on multiple devices</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Xfinity Stream TV App</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">X1 Voice Remote</span>
    </div>
    <div className="feature-item">
        <span className="feature-check">✓</span>
        <span className="feature-text">Unlimited nationwide calling with excellent call clarity</span>
    </div>
</div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="standard-call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>

                    {/* Premium Plan */}
                    <div className="offer-card offer-card-premium">
                        <div className="offer-header">
                            <h3 className="offer-name">Fast Internet + Popular TV</h3>
                            <p className="offer-price">$85<span>/Mo</span></p>
                        </div>
                        <div className="offer-features">
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Access to 125+ channels
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Download speeds up to 500 Mbps
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">20 Hour DVR service + HD (X1 TV box separate)</span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">HD streaming on multiple devices
                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Xfinity Stream TV App

                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">X1 Voice Remote


                                </span>
                            </div>
                            <div className="feature-item">
                                <span className="feature-check">✓</span>
                                <span className="feature-text">Thousands of On Demand titles



                                </span>
                            </div>
                        </div>
                        <div className="offer-footer">
                            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
                            <p className="disclaimer">Restrictions apply. Internet or TV req'd. Taxes extra. Pricing subj. to change</p>
                        </div>
                    </div>
                </div>

            </div>

            <header class="xfnn-header2">
                <img src={provider2} alt="Xfinity Authorized Retailers" class="xfnn-logo" />
            </header>

         <WideCoverage/>
            <Footer />
        </>
    );
};

export default XfinityTv;